import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { APP_CONSTANTS } from 'src/app/constants/constants';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
	selector: 'app-notifications',
	templateUrl: './notifications.component.html',
	styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
	APP_CONSTANTS = APP_CONSTANTS;
	
	user_details: any;
	user_role: any;

	constructor(
		private storageService: StorageService,
		public commonService: CommonService,
		private router: Router,
	) { }

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");

		if (this.user_details.role.role == 3) {
			this.user_role = "Executive";
		} else if (this.user_details.role.role == 4) {
			this.user_role = "Advisor Manager";
		} else if (this.user_details.role.role == 5) {
			this.user_role = "Advisor";
		} else if (this.user_details.role.role == 6) {
			this.user_role = "AFA";
		} else if (this.user_details.role.role == 7) {
			this.user_role = "Assistant";
		} else if (this.user_details.role.role == 8) {
			this.user_role = "Relationship Manager";
		} else if (this.user_details.role.role == 10) {
			this.user_role = "Leadership";
		} else if (this.user_details.role.role == 11) {
			this.user_role = "Marketing Team";
		} else if (this.user_details.role.role == 12) {
			this.user_role = "Wholesaler";
		}

	}

	notifications_data: any;
	notifications_data_loaded: boolean = false;
	getNotioficationsData() {
		this.notifications_data_loaded = false;

		let route: any = "/notificationsonly/";

		// if (this.user_details.role.role == 3) {
		// 	route = "/";
		// } else if (this.user_details.role.role == 4) {
		// 	route = "/";
		// } else if (this.user_details.role.role == 5) {
		// 	route = "/advisornotificationsonly/";
		// } else if (this.user_details.role.role == 6) {
		// 	route = "/";
		// } else if (this.user_details.role.role == 7) {
		// 	route = "/";
		// } else if (this.user_details.role.role == 8) {
		// 	route = "/";
		// } else if (this.user_details.role.role == 10) {
		// 	route = "/";
		// } else if (this.user_details.role.role == 11) {
		// 	route = "/";
		// } else if (this.user_details.role.role == 12) {
		// 	route = "/";
		// }

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.notifications_data = res['data'];
				this.notifications_data_loaded = true;

			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	show_notifiucations: boolean = false;
	openNotifications() {
		this.show_notifiucations = true;
		this.getNotioficationsData();
	}

	closeNotifications() {
		this.show_notifiucations = false;
	}
	

}
